export default {
  reviewCompleteHeader: 'Controleren en voltooien',
  participants: 'Deelnemers',
  enterParticipantInfoText:
    'Vul de vereiste gegevens in om door te gaan naar afrekenen.',
  purchaser: 'Koper',
  firstName: 'Voornaam',
  lastName: 'Achternaam',
  email: 'E-mail',
  optionalEmail: 'E-mail: (optioneel)',
  'phone:': 'Telefoon',
  participantFieldPlaceholder:
    'Voeg nieuwe toe of selecteer bestaande deelnemer',
  reservationSummary: 'Reserveringsoverzicht',
  editParticipantsDetails: 'Deelnemersgegevens bewerken',
  participantDetails: 'Gegevens',
  duplicatePurchaserText: 'Zelfde als koper',
  phone: 'Telefoon',
  addParticipant: 'Extra {{tierLabel}}',
  participant: 'Deelnemer',
  removeParticipant: 'Verwijderen',
  experienceCheckoutCompleted: 'Afrekenen ervaring voltooid',
  experienceCartCheckout: 'Winkelwagen ervaring afrekenen',
  experienceLimitReached:
    'Sorry, deze ervaring heeft het maximale aantal deelnemers bereikt',
  payment: 'Betaling',
  duration: 'Duur',
  discountCode: 'Kortingscode',
  removeCode: 'Code verwijderen',
  invalidCodeValidation: 'Ongeldige couponcode',
  networkErrorDiscountCode: 'Er ging iets mis aan onze kant',
  onlyOneCouponCodeAllowed: 'Er is slechts één couponcode toegestaan',
  creditCodeHasAlreadyBeenApplied: 'Kredietcode is al toegepast',
  discount: 'Korting',
  promo: 'Promotie',
  promoCode: 'Promotiecode',
  apply: 'Toepassen',
  total: 'Totaal',
  subTotal: 'Subtotaal',
  includes: 'Inclusief',
  and: 'en',
  addHostNotes: 'Voeg notities toe voor uw gastheer',
  brandAggreementText:
    'Ik ga akkoord met, of ik verklaar dat ik bevoegd ben namens de deelnemer(s) akkoord te gaan met, de algemene voorwaarden van de',
  termsAggreementValidation: 'Ga alstublieft akkoord met de voorwaarden',
  firstNameValidation: 'Voornaam is verplicht',
  lastNameValidation: 'Achternaam is verplicht',
  emailValidation: {
    emailRequiredText: 'E-mail is verplicht',
    invalidEmail: 'Ongeldig e-mailadres',
    not_specified: 'Onjuist e-mailadres',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Ongeldig telefoonnummer',
    not_specified: 'Ongeldig',
    phoneRequiredText: 'Telefoonnummer is verplicht',
  },
  participantFirstNameValidation: 'Voornaam van deelnemer is verplicht',
  participantLastNameValidation: 'Achternaam van deelnemer is verplicht',
  complete: 'Voltooien',
  '404Message': 'Niet gevonden',
  waiting: 'Wachten...',
  complimentary: 'Gratis',
  confirmationHeader: 'Uw ervaring is geboekt!',
  confirmationText:
    'Een bevestigingsmail is verzonden naar {{email}} met aanvullende details',
  viewAll: 'Bekijk alle ervaringen',
  paymentMethod: 'Betaalmethode',
  creditCard: 'Creditcard',
  roomCharge: 'Kamerrekening',
  memberCharge: 'Ledenrekening',
  roomOrReservationNumber: 'Kamernummer of bevestigingsnummer',
  roomNumber: 'Kamernummer',
  roomNumberLegacy: 'Kamernummer / Bevestigingscode',
  memberNumber: 'Lidnummer',
  kicc: 'Eenvoudig betalen',
  chargeValidation: 'Kamernummer en achternaam zijn verplicht',
  memberNumberValidation: 'Lidnummer is verplicht',
  invalidRoomNumber: 'Kamernummer is ongeldig',
  invalidRoomNumberLegacy: 'Kamernummer of bevestigingscode is ongeldig',
  invalidMemberNumber: 'Lidnummer is ongeldig',
  invalidPhoneNumber: 'Telefoonnummer is ongeldig',
  requiredPhoneNumber: 'Telefoonnummer is verplicht',
  guestNameIsRequired: 'Naam van de gast is verplicht',
  roomNumberIsRequired: 'Kamernummer is verplicht',
  roomNumberIsRequiredLegacy: 'Kamernummer of bevestigingscode is verplicht',
  roomOrReservationNumberIsRequired:
    'Kamernummer of bevestigingsnummer is verplicht',
  cardNumberIncomplete: 'Kaartnummer is onvolledig',
  lastNameValidationError: 'Achternaam is verplicht',
  isReqd: 'is verplicht',
  reservationCode: 'Reserverings-/bevestigingsnummer',
  nonHotelGuest: 'Geen hotelgast',
  onPropertyGuest: 'Gast op locatie',
  preArrivalGuest: 'Gast voor aankomst',
  cardNumber: 'Kaartnummer',
  pmsValidationErrorMessage:
    'Ongeldige achternaam of kamernummer of bevestigingsnummer',
  pmsDateValidationErrorMessage:
    'Sorry! De ervaringsdatum valt niet tussen uw aankomst- en vertrekdatum.',
  fullName: 'Volledige naam',
  checkout: 'Afrekenen',
  editParticipants: 'Deelnemers bewerken',
  private: 'Privé',
  browseAllExperieces: 'Alle ervaringen bekijken',
  payWithCreditCard: 'Betalen met creditcard',
  payWithRoomCharge: 'Betalen via kamerrekening',
  payWithMemberCharge: 'Betalen via ledenrekening',
  payWith: 'Betalen met',
  bookBulkErrorByCard:
    'Er was een probleem bij het bevestigen van uw boeking. Uw kaart is niet belast.',
  bookBulkErrorByRoomCharge: 'Ongeldige achternaam en kamernummer.',
  bookBulkErrorByMemberCharge: 'Ongeldige achternaam en lidnummer.',
  reviewCancellation: 'Annulering controleren',
  selectAReservationToCancel: 'Selecteer een reservering om te annuleren',
  confirmCancellation: 'Annulering bevestigen',
  cancellable: 'Annuleerbaar',
  cancelled: 'Geannuleerd',
  deadlinePassed: 'Deadline verstreken',
  noCancellations: 'Geen annuleringen',
  reviewReschedule: 'Uw reservering',
  selectAReservationToReschedule: 'Selecteer een reservering om te verzetten',
  confirmReservation: 'Reservering bevestigen',
  confirm: 'Bevestigen',
  selectADateAndTime: 'Selecteer een datum en tijd',
  noOtherSessionsAvailableForThisExperience:
    'Er zijn geen andere sessies beschikbaar voor deze ervaring.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Deze reservering kan niet meer worden verzet. Stuur een e-mail naar {{brandEmail}}',
  thisReservationCannotBeRescheduled: 'Deze reservering kan niet worden verzet',
  noTimesAvailable: 'Geen tijden beschikbaar',
  noBookingsAvailable: 'Geen boekingen beschikbaar',
  youPaid: 'U heeft betaald',
  refund: 'Terugbetaling',
  yourRefund: 'Uw terugbetaling',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Uw terugbetaling wordt verwerkt naar de oorspronkelijke betaalmethode.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Deze reservering kan niet meer worden geannuleerd. Stuur een e-mail naar {{brandEmail}}',
  reservationCancelled: 'Reservering geannuleerd',
  thisReservationCannotBeCancelled:
    'Deze reservering kan niet worden geannuleerd',
  thisReservationHasAlreadyBeenCancelled: 'Deze reservering is al geannuleerd',
  theHotel: 'het hotel',
  cancelling: 'Annuleren',
  somethingWentWrong: 'Er ging iets mis',
  previouslyRefunded: 'Eerder terugbetaald',
  remainingBalance: 'Resterend saldo',
  notEnoughPoints: 'Niet genoeg punten',
  notEnoughPointsDescription:
    'U heeft niet genoeg World of Hyatt-punten om deze aankoop te voltooien.',
  currentPointsBalance: 'Huidig puntensaldo: {{count, number}}',
  points: 'punten',
  pointsWithCount_one: '{{count, number}} punt',
  pointsWithCount_other: '{{count, number}} punten',
  payWithHyattPoints: 'Betalen met Hyatt-punten',
  pleaseSignIn: 'Gelieve in te loggen',
  worldOfHyattPoints: 'World of Hyatt-punten',
  bookBulkErrorByNotEnoughSeats:
    'Niet genoeg plaatsen beschikbaar voor deze sessie. Probeer een andere sessie.',
  phoneNumber: 'Telefoonnummer',
  requestToBookConfirmationText:
    'Een bevestigingsmail is verzonden naar {{email}}',
  reservationRescheduled: 'Reservering verzet',
  yourReservationWasRescheduledTo: 'Uw reservering is verzet naar',
  viewExperiences: 'Ervaringen bekijken',
  joinBook: 'Word lid en boek',
  signInBook: 'Inloggen en boeken',
  signAndJoin: 'Inloggen of lid worden om te boeken',
  signAndJoinDescription:
    'World of Hyatt FIND-ervaringen zijn exclusief voor World of Hyatt-leden. Log in of word lid om te boeken en punten te verdienen. Wilt u liever geen lid worden? U kunt nog steeds niet-exclusieve ervaringen boeken door de World of Hyatt-ervaring uit uw winkelwagen te verwijderen.',
  promoOrFind: 'Promotie- of Find-kredietcode',
  hyattTermsAndConditions: 'Algemene voorwaarden',
  hyattTermsAndConditionsAgreement:
    'Door deze boeking te bevestigen, accepteer ik het annuleringsbeleid. Ik heb ook het gebruik van mijn persoonlijke gegevens gelezen en erkend in overeenstemming met het',
  hyattTermsAndConditionsLink: 'Hyatt Privacybeleid',
  hyattWaiverText:
    'Door deze ervaring te kopen, ga ik akkoord, begrijp ik en erken ik, zowel namens mijzelf als namens elke persoon die deelneemt aan de door mij gekochte ervaring (indien van toepassing), het volgende',
  hyattWaiverLink: 'algemene verklaring van afstand',
  priceDisclaimer: 'Inclusief kosten vóór belastingen',
  curatedRecommendations: 'Samengestelde aanbevelingen',
  moreExperiencesYouMightLike: 'Meer ervaringen die u misschien leuk vindt',
  similarExperiencesAvailableToBookDirectly:
    'Vergelijkbare ervaringen direct te boeken',
  experiencesAvailableAroundYourBookingDate:
    'Ervaringen beschikbaar rond uw boekingsdatum',
  confirmationEmailSent:
    'We hebben uw bevestiging naar {{email}} gestuurd met meer details.',
  youreBooked: 'U bent geboekt',
  purchaserInformation: 'Kopersinformatie',
  requiredFieldIndicator: '* geeft een verplicht veld aan',
  resourceSelectionTitle: 'Kies je opties',
  resourceSelectionDescription: 'Kies een optie voor elk item in je boeking.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Selecteer {{attributeName}}',
  resourceValueSoldOut: '{{label}} (uitverkocht)',
  resourceValueUnavailableWith: '{{label}} (niet beschikbaar met {{picks}})',
  resourceOptionsUnavailable:
    'We konden de opties voor dit tijdstip niet laden. Probeer het opnieuw.',
  resourceOptionsRetry: 'Opnieuw proberen',
  changeResourceSelections: 'Wijzig je keuzes',
};
